/*
 * This file is used by module bundlers (browserify/webpack/etc) when
 * including a stream implementation. We use "readable-stream" to get a
 * consistent behavior between nodejs versions but bundlers often have a shim
 * for "stream". Using this shim greatly improve the compatibility and greatly
 * reduce the final size of the bundle (only one stream implementation, not
 * two).
 */
module.exports = require("stream");



/*****************
 ** WEBPACK FOOTER
 ** ./~/jszip/lib/readable-stream-browser.js
 ** module id = 258
 ** module chunks = 0
 **/